import React from "react";
import { Box, Text, useColorModeValue as mode } from "@chakra-ui/react";

const MessageLogRow = ({
  id,
  text,
  direction,
  toNumber,
  fromNumber,
  customerName,
  date,
  time,
  jobId,
  index,
  header,
  selected,
  onSelect,
}) => {
  const rowBg = selected
    ? mode("blue.100", "blue.700")
    : index % 2 === 0
    ? mode("white", "gray.800")
    : mode("gray.100", "gray.700");

  return (
    <Box
      display='grid'
      gridTemplateColumns={{
        base: "60px 60px 90px 90px 120px 200px 50px",
        md: "90px 80px 120px 120px 150px 1fr 80px 60px",
      }}
      bg={rowBg}
      alignItems='stretch'
      borderBottom='1px solid'
      borderColor={mode("gray.200", "gray.600")}
      onClick={() => {
        if (onSelect) onSelect(index);
      }}
      cursor='pointer'
      minH='40px'
      fontSize={{ base: "xs", md: "sm" }}
      w='100%'
      minW='fit-content'
    >
      {/* <Box
        flex='1'
        borderRight='1px solid'
        borderColor={mode("gray.200", "gray.600")}
        pl='2'
        // onClick={() => {
        //   if (onDouble) onDouble(index);
        // }}
      >
        <Text
          textAlign='left'
          fontWeight={header ? "bold" : "normal"}
          //p={2}
          textDecoration={header ? "none" : "underline"}
          textUnderlineOffset='2px'
          p='1'
        >
          {id}
        </Text>
      </Box> */}
      <Box borderRight='1px solid' borderColor={mode("gray.200", "gray.600")}>
        <Text textAlign='left' fontWeight={header ? "bold" : "normal"} p={1}>
          {date}
        </Text>
      </Box>
      <Box borderRight='1px solid' borderColor={mode("gray.200", "gray.600")}>
        <Text textAlign='left' fontWeight={header ? "bold" : "normal"} p={1}>
          {time}
        </Text>
      </Box>
      <Box borderRight='1px solid' borderColor={mode("gray.200", "gray.600")}>
        <Text fontWeight={header ? "bold" : "normal"} p={1}>
          {toNumber}
        </Text>
      </Box>
      <Box borderRight='1px solid' borderColor={mode("gray.200", "gray.600")}>
        <Text fontWeight={header ? "bold" : "normal"} p={1}>
          {fromNumber}
        </Text>
      </Box>
      <Box borderRight='1px solid' borderColor={mode("gray.200", "gray.600")}>
        <Text fontWeight={header ? "bold" : "normal"} p={1}>
          {customerName}
        </Text>
      </Box>
      <Box borderRight='1px solid' borderColor={mode("gray.200", "gray.600")}>
        <Text
          noOfLines={selected ? undefined : 1}
          textAlign='left'
          fontWeight={header ? "bold" : "normal"}
          p={1}
          overflow={"hidden"}
        >
          {text}
        </Text>
      </Box>
      <Box borderRight='1px solid' borderColor={mode("gray.200", "gray.600")}>
        <Text fontWeight={header ? "bold" : "normal"} p={1}>
          {header || !jobId ? (
            jobId
          ) : (
            <a
              href={`/job/${jobId}`}
              style={{ color: "#3182ce", textDecoration: "underline" }}
              onClick={(e) => e.stopPropagation()}
            >
              {jobId}
            </a>
          )}
        </Text>
      </Box>
      <Box borderRight='1px solid' borderColor={mode("gray.200", "gray.600")}>
        <Text textAlign={header ? "left" : "right"} fontWeight={header ? "bold" : "normal"} p={1}>
          {header ? direction : direction === 1 ? "In" : "Out"}
        </Text>
      </Box>
    </Box>
  );
};

export default MessageLogRow;
